import React, { useState } from 'react';

import NwDrawer from '@components/Gui/NwDrawer';
import ModelAgencyForm from '@components/ModelAgencies/ModelAgencyForm';

const AgencyModelsDrawer = ({ onClose, viewMode, agencyModel, excludedModels, agencyID }) => {
    const [touchForm, setTouchForm] = useState(false);
    return (
        <NwDrawer
            touchForm={touchForm}
            onTouchForm={setTouchForm}
            onClose={onClose}
            title={viewMode === 'INSERTING' ? 'Add Model Agency Relationship' : 'Edit Model Agency Relationship'}
        >
            {viewMode === 'INSERTING' && (
                <ModelAgencyForm
                    agencyID={agencyID}
                    excludedModels={excludedModels}
                    onCancel={onClose}
                    onSave={onClose}
                    onTouchForm={setTouchForm}
                />
            )}
            {viewMode === 'EDITING' && (
                <ModelAgencyForm
                    agencyID={agencyID}
                    modelAgency={agencyModel}
                    onCancel={onClose}
                    onSave={onClose}
                    onTouchForm={setTouchForm}
                />
            )}
        </NwDrawer>
    );
};

export default AgencyModelsDrawer;
